import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { forgotPassword } from "../api/authReset";
import { useApiError } from "../hooks/useApiError";
import { AuthShell } from "../features/auth/AuthShell";
import { NeuButton, NeuInput } from "../components/neu/Neu";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const describe = useApiError();
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ busy: false, sent: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, sent: false, error: "" });
    try {
      await forgotPassword(email.trim());
      setState({ busy: false, sent: true, error: "" });
    } catch (err) {
      setState({ busy: false, sent: false, error: describe(err) });
    }
  };

  return (
    <AuthShell title={t("reset.forgotTitle")} subtitle={t("reset.forgotSubtitle")} testId="forgot-card">
      {state.sent ? (
        <p className="mt-6 text-sm font-semibold text-primary" data-testid="forgot-sent">
          {t("reset.sent")}
        </p>
      ) : (
        <form className="mt-6 space-y-4" onSubmit={submit}>
          <NeuInput
            data-testid="forgot-email"
            type="email"
            required
            placeholder={t("auth.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {state.error ? (
            <p data-testid="forgot-error" className="text-sm font-semibold text-destructive">
              {state.error}
            </p>
          ) : null}
          <NeuButton
            variant="primary"
            type="submit"
            data-testid="forgot-submit"
            disabled={state.busy}
            className="w-full py-4"
          >
            {state.busy ? t("app.loading") : t("reset.sendLink")}
          </NeuButton>
        </form>
      )}
      <Link to="/login" className="mt-5 block text-center text-xs font-semibold text-primary" data-testid="forgot-back">
        {t("reset.backToLogin")}
      </Link>
    </AuthShell>
  );
}
